/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./categorizerNavbar.scss');

const deps = [
  require('angular-ui-router'),
  require('./add').name,
  require('data/collection/categorizerRule').name,
  require('ui/web/confirmDialog').name,
  require('ui/bk/applyRulesButton').name,
];

module.exports = angular
  .module('bench.ui.categorizerNavbar', deps)

  .directive('blCategorizerNavbar', () => ({
    restrict: 'E',
    scope: {
      rulesId: '=',
    },
    bindToController: true,
    template: require('./categorizerNavbar.html'),
    controller: require('./categorizerNavbarCtrl.js'),
    controllerAs: 'vm',
  }));
